import React from "react";
import PropTypes from "prop-types";

const InsurerSection = ({ title, children: fields }) => {
  return (
    <div className="section">
      <h3 className="section-title">{title}</h3>
      {fields}
    </div>
  );
};

InsurerSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.object,
};

export default InsurerSection;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/formSections/InsurerSection.js